import RepositoryAxios from '@/repositories/repositoryAxios'

const devUrl = import.meta.env.VITE_DEV_API_URL

const updatePreference = {
  async updatePreference(settings: any = {}) {
    return await RepositoryAxios(devUrl, settings)
  }
}
export default updatePreference
